var SocialSSAnnouncements = {
  init: function () {
    this.setVariables();
    this.retrieveAnnouncements();
  },
  setVariables: function () {
    this.$announcementSection = $("#announcementSection");
    this.$announcementList = $("#annPanel .announce__list");
    this.$announcementCount = $("#announcementCount");
    this.$announce__title = $("#announce__title");
    this.$noAnnouncement = $("#noAnnouncement");
    this.$announcementPanel = $("#annPanel");
  },
  retrieveAnnouncements: function () {
    var url = Config.contextPath + "/controller/get/announcement/";
    $.get(url)
      .done(this.handleResponse.bind(this));
  },
  handleResponse: function (response) {
    if (!response.announcements || !Array.isArray(response.announcements) || response.announcements.length === 0) {
      this.$announcementSection.hide();
      this.$noAnnouncement.removeClass('hide');
      return;
    }
    if (response.announcementDisplayFormat.toLowerCase() === 'carousel') {
      this.displayCarousel(response);
    } else {
      this.displayList(response);
    }
  },
  displayCarousel: function (response) {
    $(".announce__arrow").css("display", "none");
    $("#annPanel").css("display", "none");
    const $slider = $('<div class="slider"></div>');
    const $slides = $('<div class="slides"></div>');
    const $controls = $('<div class="controls"></div>');
    const $prevBtn = $('<button class="slide-prev">&#10094;</button>');
    const $nextBtn = $('<button class="slide-next">&#10095;</button>');
    const $dots = $('<div class="dots"></div>');
    let newCount = 0;
    let timer;
    const delay = response.announcementCarouselRotation;

    response.announcements.sort((a, b) => b.isNew - a.isNew);

    response.announcements.forEach((announcement, index) => {
      const $slide = $(`
        <div class="slide">
          <div class="slide-content">
            <h3 class="new-tag">${announcement.isNew ? 'NEW' : ''}</h3>
            <p>${announcement.text}</p>
          </div>
        </div>
      `);
      $slides.append($slide);

      const $dot = $('<span class="dotItem"></span>');
      if (index === 0) $dot.addClass('active');
      $dots.append($dot);

      if (announcement.isNew) {
        newCount++;
      }
    });

    if (newCount > 0) {
      this.$announcementCount.html(newCount).show();
      this.$announcementSection.addClass("-new");
    }

    $controls.append($prevBtn, $dots, $nextBtn);
    $slider.append($slides, $controls);
    this.$announcementSection.append($slider);

    let currentSlide = 0;
    const $slideItems = $slides.children('.slide');
    const $dotItems = $dots.children('.dotItem');

    const showSlide = (index) => {
      if (timer) {
        clearInterval(timer);
      }
      if (delay > 0) {
        timer = setInterval(() =>
          showSlide(currentSlide + 1), (delay > 60 ? 60 : delay) * 1000
        );
      }
      currentSlide = (index + $slideItems.length) % $slideItems.length;
      const offset = -currentSlide * 100;
      $slides.css('transform', `translateX(${offset}%)`);
      $dotItems.removeClass('active').eq(currentSlide).addClass('active');
    };

    $nextBtn.on('click', () => {
      showSlide(currentSlide + 1);
      $nextBtn.addClass('activeBtn');
      $prevBtn.removeClass('activeBtn');
    });
    $prevBtn.on('click', () => {
      showSlide(currentSlide - 1);
      $nextBtn.removeClass('activeBtn');
      $prevBtn.addClass('activeBtn');
    });
    $dotItems.on('click', function () { showSlide($(this).index()); });

    showSlide(currentSlide);
  },
  displayList: function (response) {
    let newCount = 0;
    const announcementDisplaySettings = response.announcementDisplaySettings.toLowerCase();
    
    if (announcementDisplaySettings === "show expanded") {
      this.$announcementPanel.addClass("in");
    }
    else {
      if (announcementDisplaySettings === "show collapsible") {
        this.$announcementPanel.removeClass("in");
      }
    }

    if (announcementDisplaySettings !== "show expanded" &&
        announcementDisplaySettings !== "show collapsible" &&
        announcementDisplaySettings !== "show expanded when new") {
          this.$announcementPanel.addClass("in");
    }

    response.announcements.forEach((announcement, index) => {
      const $li = $("<li></li>").addClass("announce__item");
      const $accordionLink = $("<a class='announce__toggle-link single-announcement' role='button' data-toggle='collapse' aria-expanded='false'></a>");
      const $contentDiv = $("<div></div>").html(announcement.text);

      if (announcement.isNew) {
        newCount++;
        $li.addClass("-new");
      }

      $accordionLink.attr("href", "#" + index);
      $accordionLink[0].innerHTML = announcement.displayText.substring(0, 121) + "<span class='glyphicon glyphicon-menu-up'></span>";
      $accordionLink.attr("aria-controls", index + "");
      $contentDiv.attr("id", index + "");
      $contentDiv.addClass("collapse in");
      $accordionLink.append($contentDiv);
      $li.append($accordionLink);
      this.$announcementList.append($li);
    });

    if (newCount > 0) {
      this.$announcementCount.html(newCount).show();
      this.$announcementSection.addClass("-new");
      if (announcementDisplaySettings === "show expanded when new") {
        this.$announcementPanel.addClass("in");
      }
    }
  }
};